import foundation from "vendor/foundation/js/foundation/foundation";
import "vendor/foundation/js/foundation/foundation.dropdown";
import "vendor/foundation/js/foundation/foundation.tab";
import "vendor/foundation/js/foundation/foundation.tooltip";
import "vendor/foundation/js/foundation/foundation.reveal";
import "vendor/foundation/js/foundation/foundation.orbit";
export default foundation;
